// extracted by mini-css-extract-plugin
export default {"headLines":"index_headLines_rHJF1","threeImageAd":"index_threeImageAd_5i5Ih","threeImage":"index_threeImage_RBUso"};